import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Map, AlertCircle, Settings } from 'lucide-react';

const navItems = [
  { path: '/', icon: Map, labelKey: 'nav.home', id: 'nav-home' },
  { path: '/emergency', icon: AlertCircle, labelKey: 'nav.emergency', id: 'nav-emergency', isEmergency: true },
  { path: '/settings', icon: Settings, labelKey: 'nav.settings', id: 'nav-settings' },
];

export default function BottomNav() {
  const { t } = useTranslation();

  return (
    <nav className="bottom-nav" role="navigation" aria-label="메인 네비게이션">
      {navItems.map(({ path, icon: Icon, labelKey, id, isEmergency }) => (
        <NavLink
          key={path}
          to={path}
          id={id}
          end={path === '/'}
          className={({ isActive }) =>
            `nav-item${isEmergency ? ' emergency' : ''}${isActive ? ' active' : ''}`
          }
          aria-label={t(labelKey)}
        >
          <span className="nav-icon">
            <Icon size={isEmergency ? 32 : 28} strokeWidth={1.8} />
          </span>
        </NavLink>
      ))}
    </nav>
  );
}
